import { DataActiveStatusEnum } from "../../Category/types";
import { GroupProductState, IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  status: DataActiveStatusEnum.ACTIVE,
  groupId: "",
  allergicImages: [],
  featuredImage: "",
  packageId: "",
  packageTitle: "",
  groupTitle: ""
};

export const initialState: GroupProductState = {
  formData: {
    ...defaultFormData,
  },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  allGroupList: []
};
